import { Injectable } from '@angular/core';

import { AuthGuard } from '@platform/auth/auth.guard';
import { CompositeGuard } from '@platform/routing/composite.guard';
import { CockpitGuard } from './cockpit.guard';

@Injectable({
  providedIn: 'root',
})
export class CockpitCompositeGuard extends CompositeGuard {
  constructor(authGuard: AuthGuard, cockpitGuard: CockpitGuard) {
    super([authGuard, cockpitGuard]);
  }
}
